import  * as React from "react";
import { observer } from "mobx-react";
import { IPanelWithHighlightedResultsParams } from "./IPanelWithHighlightedResultsParams";
import { IReportMeasurement, ISingleMeasurementParameter } from "Data";
import { SingleTile } from "../../TileControl/SingleTile";
import { ISingleTileProps } from "../../TileControl/ISingleTileProps";
import { HighlightedResultsDetails } from "./../HighlightedResultsDetails/HighlightedResultsDetails";
import { IHighlightedResultsDetailsParams } from "./../HighlightedResultsDetails/IHighlightedResultsDetailsParams";
import { ParameterHelper } from "MeasurementsCalculations";



@observer export class PanelWithHighlightedResults extends React.Component<IPanelWithHighlightedResultsParams>{
    constructor(props: IPanelWithHighlightedResultsParams) {
        super(props, undefined);
    }

    checkStrokeIndex(stroke: IReportMeasurement): number {
        if(this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.strokes){
            if(this.props.selectedStroke){
                return this.props.selectedGroupOfStrokes.strokes.indexOf(this.props.selectedStroke) + 1;
            }            
        }
        return 1;
        
    }

    private getHighlightedResultsDetailsParams() {
        const result: IHighlightedResultsDetailsParams = {
            selectedGroupOfStrokes: this.props.selectedGroupOfStrokes,
            selectedStroke: this.props.selectedStroke,
            selectedAverage: this.props.selectedAverage,
            cleanSelectedShot: () =>{
            this.props.cleanSelectedShot();
        }
        };
        return result;
    }

    private getSingleTileParams(tileKind: string, parameter: ISingleMeasurementParameter)  {
        let valueOfParameter = '';
        switch (tileKind) {
            case 'EmptyTile':                
            case 'TileWithoutValues':                 
                break;            
            case 'SelectedAverageTile':
                if(this.props.selectedAverage){
                    valueOfParameter = ParameterHelper.getParameterValue(this.props.selectedAverage, parameter.propertyName, this.props.unitPresentation);
                }
                break;                
            case 'SelectedStrokeTile':
                if(this.props.selectedStroke){
                    valueOfParameter = ParameterHelper.getParameterValue(this.props.selectedStroke, parameter.propertyName, this.props.unitPresentation);
                }                    
                break;                
            default: 
                valueOfParameter = '';
                break;
        }            
       
        const result: ISingleTileProps = {
            title: tileKind === 'EmptyTile' ? '' : parameter.title,
            unit: tileKind === 'EmptyTile' ? '' : parameter.displayUnit,
            value: valueOfParameter,
            isWeb: this.props.isWeb,
            isIos: this.props.isIos,
            isTps: this.props.isTps,
            infoPage: parameter.myTrackManPage,
            color: this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.color ? this.props.selectedGroupOfStrokes.color : '#c1c1c1',
            isEmpty: tileKind === 'EmptyTile' ? true : false,
            enableInfoModal: true,
            setAdditionalInfoUrl: this.props.setAdditionalInfoUrl
        };
        return result;
    }

    render() {
        return <div className="PanelWithHighlightedResults col-xs-12">
            { /* Row with selected stroke */}
            {this.props.selectedGroupOfStrokes && this.props.selectedStroke && this.props.selectedAverage == null &&
                <div>
                <HighlightedResultsDetails {...this.getHighlightedResultsDetailsParams() }></HighlightedResultsDetails>
                    
                    <div className="container-for-stroke-row hidden-print">
                        {
                            this.props.measurementParameters.map((parameter, i) => {
                                if (parameter.isVisible) {
                                    return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('SelectedStrokeTile', parameter) }></SingleTile>
                                }
                                return null;
                            })}
                        {this.props.measurementParameters.map((parameter, i) => {
                            if (i < (10 - this.props.measurementParameters.filter((x) => { return x.isVisible; }).length)) {
                                return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('EmptyTile', parameter) }></SingleTile>
                            }
                            return null;
                        })
                        }
                    </div>
                </div>
            }
            { /* Row with selected stroke */}
            {this.props.selectedGroupOfStrokes && this.props.selectedAverage != null &&
                <div>
                    <HighlightedResultsDetails {...this.getHighlightedResultsDetailsParams() }></HighlightedResultsDetails>
                    <div className="container-for-stroke-row  hidden-print">
                        {
                            this.props.measurementParameters.map((parameter, i) => {
                                if (parameter.isVisible) {
                                    return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('SelectedAverageTile', parameter) }></SingleTile>
                                }
                                return null;
                            })}
                        {this.props.measurementParameters.map((parameter, i) => {
                            if (i < (10 - this.props.measurementParameters.filter((x) => { return x.isVisible; }).length)) {
                                return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('EmptyTile', parameter) }></SingleTile>
                            }
                            return null;
                        })
                        }
                    </div>
                </div>
            }
            { /*  Row with empty parameters shown when the stroke and the average is not selected*/}
            {this.props.selectedStroke == null && this.props.selectedAverage == null &&
                <div>
                    <HighlightedResultsDetails {...this.getHighlightedResultsDetailsParams() }></HighlightedResultsDetails>
                    <div>
                        {this.props.measurementParameters.filter(x => x.isVisible).map((parameter, i) => {
                        return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('TileWithoutValues', parameter) }></SingleTile>
                        })}
                        {this.props.measurementParameters.map((parameter, i) => {
                            if (i < (10 - this.props.measurementParameters.filter(x => x.isVisible).length)) {
                                return <SingleTile className="single-tile" key={parameter.propertyName} data-toggle="modal"  {...this.getSingleTileParams('EmptyTile', parameter) }></SingleTile>
                            }
                            return null;
                        })
                        }
                    </div>
                </div>
            }
        </div >;
    }
}
